import { render, staticRenderFns } from "./itemsMovidos.vue?vue&type=template&id=7717b62f"
import script from "./itemsMovidos.vue?vue&type=script&lang=js"
export * from "./itemsMovidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports